import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {LoginComponent} from "./pages/login/login.component";
import {RegisterComponent} from "./pages/register/register.component";
import {VerifyComponent} from "./pages/verify/verify.component";
import {BillingComponent} from "./pages/billing/billing.component";
import {ForgotPasswordComponent} from "./pages/reset-password/forgot-password.component";
import {LandingComponent} from "./pages/landing/landing.component";
import {AuthGuard} from "./auth/auth-guard.service";
import {SubscriptionCheckComponent} from "./pages/subscription-check/subscription-check.component";
import {MainLayout} from "./layout/main.layout";
import {UpgradePlanComponent} from "./pages/upgrade-plan/upgrade-plan.component";
import {ConversationComponent} from "./pages/email-agent/conversation.component";
import {EmailAgentComponent} from "./pages/email-agent/email-agent.component";
import {MyWalletComponent} from "./pages/my-wallet/my-wallet.component";
import {ProfileComponent} from "./pages/profile/profile.component";
import {CeuListComponent} from "./pages/ceu-list/ceu-list.component";
import {UserDashboardComponent} from "./pages/dashboard/user-dashboard.component";
import {AdminConversationComponent} from "./pages/admin-board/admin-conversation.component";
import {ResetPasswordComponent} from "./pages/reset-password/reset-password.component";
import {UserManagementDetailComponent} from "./pages/admin-board/user-management-detail.component";
import {UserManAssessmentEditorComponent} from "./pages/admin-board/user-man-assessment-editor.component";
import {MyAssessmentViewComponent} from "./pages/my-wallet/my-assessment-view.component";
import {AssociationListComponent} from "./pages/associactions/association-list.component";
import {AdminDarkLayout} from "./layout/admin-dark.layout";
import {OfficeBoardComponent} from "./pages/office-board/office-board.component";
import {AssociationFormComponent} from "./pages/associactions/association-form.component";
import {AssociationDetailComponent} from "./pages/associactions/association-detail.component";
import {AssociationEditComponent} from "./pages/associactions/association-edit.component";
import {AssociationActivityFormComponent} from "./pages/associactions/association-activity-form.component";
import {AssociationActivityDetailComponent} from "./pages/associactions/association-activity-detail.component";
import {NewCertificationComponent} from "./pages/new-certifications/new-certification.component";
import {NewCertificationFormComponent} from "./pages/new-certifications/new-certification-form.component";
import {NewCertificationDetailComponent} from "./pages/new-certifications/new-certification-detail.component";
import {NewCertificationEditComponent} from "./pages/new-certifications/new-certification-edit.component";
import {NewCertificationDomainListComponent} from "./pages/new-certifications/new-certification-domain-list.component";
import {NewCertificationDomainEditComponent} from "./pages/new-certifications/new-certification-domain-edit.component";
import {NewCertificationDomainViewComponent} from "./pages/new-certifications/new-certification-domain-view.component";
import {NewCertificationDomainFormComponent} from "./pages/new-certifications/new-certification-domain-form.component";
import {
  NewCertificationObjectiveFormComponent
} from "./pages/new-certifications/new-certification-objective-form.component";
import {
  NewCertificationObjectiveEditComponent
} from "./pages/new-certifications/new-certification-objective-edit.component";
import {UserManagementComponent} from "./pages/admin-board/user-management.component";
import {SupportInboxComponent} from "./pages/admin-board/support-inbox.component";
import {AssessmentComponent} from "./pages/admin-board/assessment.component";
import {AdminCeuComponent} from "./pages/admin-board/admin-ceu.component";
import {AdminReportComponent} from "./pages/report/admin-report.component";
import {AdminSettingComponent} from "./pages/setting/admin-setting.component";
import {UserManCeuDetailComponent} from "./pages/admin-board/user-man-ceu-detail.component";
import {WalletCeuDetailComponent} from "./pages/my-wallet/wallet-ceu-detail.component";
import {StepperCeuComponent} from "./pages/my-wallet/stepper-ceu.component";

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'verify/:code', component: VerifyComponent },
  { path: 'register', component: RegisterComponent },

  {
    path: '',
    component: MainLayout,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'upgrade-plan', component: UpgradePlanComponent, canActivate: [AuthGuard] },
      { path: 'dashboard', component: UserDashboardComponent, canActivate: [AuthGuard] },
      { path: 'home', component: UserDashboardComponent, canActivate: [AuthGuard] },
      { path: 'my-wallet', component: MyWalletComponent, canActivate: [AuthGuard] },
      { path: 'my-wallet/scorecard/:id/view', component: MyAssessmentViewComponent, canActivate: [AuthGuard] },
      { path: 'my-wallet/ceu/:id/view', component: WalletCeuDetailComponent, canActivate: [AuthGuard] },
      { path: 'my-wallet/ceu/new', component: StepperCeuComponent, canActivate: [AuthGuard] },
      { path: 'my-wallet/ceu/:id/edit', component: StepperCeuComponent, canActivate: [AuthGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: 'ceu', component: CeuListComponent, canActivate: [AuthGuard] },
      { path: 'wallet-support', component: EmailAgentComponent, canActivate: [AuthGuard] },
      { path: 'wallet-support/:id/conversation', component: ConversationComponent, canActivate: [AuthGuard] },
    ]
  },
  {
    path: 'office',
    component: AdminDarkLayout,
    children: [
      { path: '', redirectTo: 'office-dashboard', pathMatch: 'full' },
      { path: 'office-dashboard', component: OfficeBoardComponent, canActivate: [AuthGuard] },
      { path: 'association', component: AssociationListComponent, canActivate: [AuthGuard] },
      { path: 'association/add-new', component: AssociationFormComponent, canActivate: [AuthGuard] },
      { path: 'association/detail/:providerId', component: AssociationDetailComponent, canActivate: [AuthGuard] },
      { path: 'association/detail/:providerId/edit', component: AssociationEditComponent, canActivate: [AuthGuard] },
      { path: 'association/detail/:providerId/activity/add-new', component: AssociationActivityFormComponent, canActivate: [AuthGuard] },
      { path: 'association/detail/:providerId/activity/:providerActivityId/edit', component: AssociationActivityFormComponent, canActivate: [AuthGuard] },
      { path: 'association/detail/:providerId/activity/:providerActivityId/detail', component: AssociationActivityDetailComponent, canActivate: [AuthGuard] },

      { path: 'new-certification', component: NewCertificationComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/add-new', component: NewCertificationFormComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId', component: NewCertificationDetailComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/edit', component: NewCertificationEditComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain', component: NewCertificationDomainListComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain/add-new', component: NewCertificationDomainFormComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain/:domainId/edit', component: NewCertificationDomainEditComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain/:domainId/view', component: NewCertificationDomainViewComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain/:domainId/objective/:objectiveId/edit', component: NewCertificationObjectiveEditComponent, canActivate: [AuthGuard] },
      { path: 'new-certification/detail/:certificationId/domain/:domainId/objective/add-new', component: NewCertificationObjectiveFormComponent, canActivate: [AuthGuard] },

      { path: 'user', component: UserManagementComponent, canActivate: [AuthGuard] },
      { path: 'user/:id/editor', component: UserManagementDetailComponent, canActivate: [AuthGuard] },
      { path: 'user/scorecard/:id/:userId/:mode', component: UserManAssessmentEditorComponent, canActivate: [AuthGuard] },
      { path: 'user/ceu-upload/:documentId/:userId', component: UserManCeuDetailComponent, canActivate: [AuthGuard] },

      { path: 'inbox', component: SupportInboxComponent, canActivate: [AuthGuard] },
      { path: 'inbox/:id/conversation', component: AdminConversationComponent, canActivate: [AuthGuard] },

      { path: 'scorecard', component: AssessmentComponent, canActivate: [AuthGuard] },
      { path: 'inbox/:id/conversation', component: AdminConversationComponent, canActivate: [AuthGuard] },

      { path: 'event', component: AdminCeuComponent, canActivate: [AuthGuard] },

      { path: 'report', component: AdminReportComponent, canActivate: [AuthGuard] },
      { path: 'setting', component: AdminSettingComponent, canActivate: [AuthGuard] },

    ]
  },
  { path: 'landing', component: LandingComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: 'billing', component: BillingComponent, canActivate: [AuthGuard] },
  { path: 'subscription-check', component: SubscriptionCheckComponent, canActivate: [AuthGuard] },
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
